import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRisk360Full = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="var(--color-surface-interactive-secondary-hover)"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <path
      fill="var(--color-content-base-secondary)"
      d="M21.158 10.213c.672.31 1.192.958 1.192 1.76-.03 3.089-1.284 8.678-6.54 11.242-.52.247-1.1.247-1.62 0-5.257-2.564-6.51-8.153-6.54-11.242 0-.802.52-1.45 1.192-1.76l5.745-2.47c.123-.031.275-.093.428-.093.122 0 .275.062.397.093zM9.942 14.568h5.073V9.719l-5.379 2.316c0 .742.092 1.606.306 2.533m10.116 0h-5.043v6.825c3.056-1.483 4.493-4.324 5.043-6.825"
    />
  </svg>
);
export default SvgRisk360Full;
